import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Permission, PermissionGroup, PermissionType } from '../entity/permission';
import { BLService } from './bl.service';

@Injectable({ providedIn: 'root' })
export class PermissionService extends BLService {
  private RESOURCE_ENDPOINT = 'permission';

  loadPermissions(clientId: number): Observable<Permission[]> {
    return this.httpGet<Permission[]>(`${this.RESOURCE_ENDPOINT}/${clientId}`);
  }

  updatePermission(
    clientId: number,
    permissionType: PermissionType,
    permissionGroup: PermissionGroup,
    users: number[],
  ): Observable<Permission[]> {
    const body = { permissionKey: permissionType, permissionGroup, users };

    return this.httpPut<Permission[]>(`${this.RESOURCE_ENDPOINT}/${clientId}`, body);
  }
}
